import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const DatePickerWrap = styled(Box)(`
    // border: 1px red solid;

    & .MuiInputBase-root input, & label.MuiFormLabel-root {
        font-size: 14px;
    }

    & > .MuiStack-root {
        padding-top: 0;
    }

    & > .MuiStack-root {
        overflow: hidden;
    }

    & .MuiFormControl-root {
        width: 100%;
    }

    & button {
        margin-left: -30px;
        margin-top: -6px;
        padding-bottom: 0;
        padding-right: 0;
    }

    & .MuiFormControl-root {
        min-width:100px !important;
    }
`)
